
export default {
    profilePictureFallback: '/img/user/profile-picture.svg'
};